import {ApiResponse, ListQueryParams} from '../ApiClient'
import {GetAPIDomain, GetAPIHeaders, GetAPIHeadersPatch} from '../Helper'

export class InviteQueryParams extends ListQueryParams {
  WithStatus(value: any) {
    this.WithParam('status', value)
    return this
  }

  WithFileUploadId(value: any) {
    this.WithParam('fileUploadId', value)
    return this
  }
}

export class InvitationsClient {
  static async List(params: InviteQueryParams) {
    let query = (await GetAPIDomain()) + '/invites' + params.GenerateQueryString()

    return await ApiResponse.Create(() =>
      fetch(query, {
        credentials: 'include',
        headers: GetAPIHeaders(),
      }),
    )
  }

  static async Get(id: string) {
    let apiDomain = await GetAPIDomain()

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/invites/' + id, {
        credentials: 'include',
        headers: GetAPIHeaders(),
      }),
    )
  }

  static async InviteUser(
    name: string,
    surname: string,
    email: string,
    roleId: string,
    hasCrmAccess: boolean,
    hasMobileAccess: boolean,
    teamId: string,
    userTypeId: string,
    siteId?: any,
    businessUnitId?: any,
    reportsToUserId?: any,
    accessExpiry?: any,
  ) {
    let apiDomain = await GetAPIDomain()

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/invites/user', {
        credentials: 'include',
        method: 'POST',
        headers: GetAPIHeaders(),
        body: JSON.stringify({
          name: name,
          surname: surname,
          email: email,
          roleId: roleId,
          hasCrmAccess,
          hasMobileAccess,
          teamId,
          userTypeId,
          siteId,
          businessUnitId,
          reportsToUserId,
          accessExpiry,
        }),
      }),
    )
  }

  static async AcceptInvite(code: string, password: string) {
    let apiDomain = await GetAPIDomain()

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/invites/confirm/' + code, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'x-account-discovery': 'x-account-discovery',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          password: password,
        }),
      }),
    )
  }

  static async ValidateCode(code: string) {
    let apiDomain = await GetAPIDomain()

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/invites/validate', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'x-account-discovery': 'x-account-discovery',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          code: code,
        }),
      }),
    )
  }

  static async Cancel(id: string) {
    let query = (await GetAPIDomain()) + '/invites/cancel/' + id

    return await ApiResponse.Create(() =>
      fetch(query, {
        credentials: 'include',
        headers: GetAPIHeaders(),
        method: 'POST',
      }),
    )
  }

  static async Decline(id: string) {
    let query = (await GetAPIDomain()) + '/invites/decline/' + id

    return await ApiResponse.Create(() =>
      fetch(query, {
        credentials: 'include',
        headers: GetAPIHeaders(),
        method: 'POST',
      }),
    )
  }

  static async Update(id: string, name: string, surname: string) {
    let apiDomain = await GetAPIDomain()

    return await ApiResponse.Create(() =>
      fetch(apiDomain + '/invites/' + id, {
        credentials: 'include',
        method: 'PATCH',
        headers: GetAPIHeadersPatch(),
        body: JSON.stringify([
          {
            op: 'replace',
            path: 'name',
            value: name,
          },
          {
            op: 'replace',
            path: 'surname',
            value: surname,
          },
        ]),
      }),
    )
  }

  static async Delete(id: string) {
    let query = (await GetAPIDomain()) + '/invites/' + id

    return await ApiResponse.Create(() =>
      fetch(query, {
        credentials: 'include',
        headers: GetAPIHeaders(),
        method: 'DELETE',
      }),
    )
  }
}
